<div class="device-page flex flex-col gap-3">
    <app-breadcrumbs *ngIf="loadingSig() || liveDeviceSig()" [home]="breadcrumbHome" [model]="breadcrumbItems()" />
    <div *ngIf="loadingSig()" class="text-sm text-color-secondary">Loading...</div>
    <p-menubar *ngIf="loadingSig() || liveDeviceSig()" [model]="menuItems()" class="mb-1 mt-2 device-menu">
        <ng-template #start class="flex-1">
            <button pButton type="button" class="p-button-text" (click)="onBackToDevice()"><span class="p-button-label">{{ displayName(liveDeviceSig()) }}</span></button>
        </ng-template>
        <ng-template #item let-item let-root="root">
            <a pRipple class="flex items-center px-4 py-3 cursor-pointer gap-2">
                <i *ngIf="item.icon" [ngClass]="item.icon"></i>
                <span>{{ item.label }}</span>
                <span *ngIf="item.shortcut" class="ms-auto border border-surface rounded bg-emphasis text-muted-color text-xs p-1">{{ item.shortcut }}</span>
                <i *ngIf="item.items" [ngClass]="['ms-auto pi', root ? 'pi-angle-down' : 'pi-angle-right']"></i>
            </a>
        </ng-template>
    </p-menubar>
    <div *ngIf="liveDeviceSig() as d" class="flex flex-col gap-2 grow min-h-0">
        <router-outlet />
    </div>
    <div *ngIf="!loadingSig() && !liveDeviceSig()" class="flex flex-col items-center justify-center gap-3 py-20 text-center">
        <ng-container *ngIf="!errorSig(); else loadError">
            <i class="pi pi-search text-4xl text-color-secondary"></i>
            <div class="text-xl font-medium">Device not found</div>
            <p class="text-color-secondary">It may have been unclaimed or deleted, or you may not have access to it.</p>
        </ng-container>
        <ng-template #loadError>
            <i class="pi pi-exclamation-triangle text-4xl text-color-secondary"></i>
            <div class="text-xl font-medium">Failed to load device</div>
            <p class="text-color-secondary">{{ errorSig() }}</p>
        </ng-template>
        <button pButton type="button" (click)="onGotoDashboard()"><span class="p-button-label">Go to Dashboard</span></button>
    </div>
</div>

<app-deploy-version-dialog [(visible)]="deployVersionDialogVisible" />

<p-dialog header="Unclaim Device" [visible]="unclaimDialogVisible()" [modal]="true" [closable]="false" (onHide)="closeUnclaimDialog()" [style]="{width: '32rem'}">
    <ng-container *ngIf="liveDeviceSig() as d">
        <div class="mb-3">
            Unclaim <strong>{{ displayName(d) }}</strong>? This will:
            <ul class="ml-4 mt-2 list-disc">
                <li>Reset status to Pending</li>
                <li>Issue a new one-time registration code</li>
                <li>Clear any existing claim binding</li>
            </ul>
        </div>
        <div class="flex gap-2 justify-end mt-4">
            <button pButton type="button" class="p-button-text" (click)="closeUnclaimDialog()" [disabled]="loadingSig()"><span class="p-button-label">Cancel</span></button>
            <button pButton type="button" class="p-button-danger" (click)="confirmUnclaim()" [disabled]="loadingSig()"><span class="p-button-label">Unclaim</span></button>
        </div>
    </ng-container>
</p-dialog>

<p-dialog header="Change Device Location" [visible]="changeLocationDialogVisible()" [modal]="true" [closable]="false" (onHide)="closeChangeLocationDialog()" [style]="{width: '40rem', maxHeight: '80vh'}">
    <ng-container *ngIf="liveDeviceSig() as d">
        <div class="mb-3">
            <p class="mb-3">Select a new location for <strong>{{ displayName(d) }}</strong>:</p>
            <div class="flex flex-col gap-2">
                <div class="text-xs text-color-secondary mb-2" *ngIf="d.locationNodeId">Current location is highlighted below</div>
                <app-location-picker [locations]="locations() || []" [namespaceId]="d.appNamespaceId || null" [currentLocationId]="d.locationNodeId || null" [disabled]="changingLocation()" (locationSelected)="onLocationSelected($event)" />
                <div *ngIf="changeLocationError()" class="text-status-offline text-sm">{{ changeLocationError() }}</div>
            </div>
        </div>
        <div class="flex gap-2 justify-end mt-4">
            <button pButton type="button" class="p-button-text" (click)="closeChangeLocationDialog()" [disabled]="changingLocation()"><span class="p-button-label">Cancel</span></button>
            <button pButton type="button" (click)="confirmChangeLocation()" [disabled]="changingLocation() || !selectedLocationId()"><span class="p-button-label">Change Location</span></button>
        </div>
    </ng-container>
</p-dialog>
